import { ConfluenceBlogpostAri, ConfluencePageAri } from '@atlassian/ari';

/**
 * The Confluence content types the byline renders for. Teamwork Graph stores pages and blog posts
 * as distinct node types under distinct ARIs (`page/<id>` and `blogpost/<id>`), so every graph
 * query must be built from the content's type, not the bare id: a page ARI for a blog post matches
 * nothing and every section stays empty.
 *
 * `undefined` means page, the type every caller assumed before blog posts were supported.
 */
export type BylineContentType = 'page' | 'blogpost';

/** The graph node type the content binds to in a cypher `MATCH`. */
export const getContentGraphNodeLabel = (
	contentType: BylineContentType | undefined,
): 'ConfluenceBlogpost' | 'ConfluencePage' =>
	contentType === 'blogpost' ? 'ConfluenceBlogpost' : 'ConfluencePage';

/** The content's ARI, as Teamwork Graph and ORS identify it. */
export const buildContentAri = (
	cloudId: string,
	contentId: string,
	contentType: BylineContentType | undefined,
): string =>
	contentType === 'blogpost'
		? ConfluenceBlogpostAri.create({ siteId: cloudId, blogpostId: contentId }).toString()
		: ConfluencePageAri.create({ siteId: cloudId, pageId: contentId }).toString();
